import React from 'react'
import { Checkbox, FormControl, Input, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core'
import { useAllCorporationTypes } from '../../../graphql/hooks/businesses'

interface IProps {
  values: number[]
  onChange: (values: number[]) => void
}

export function CorporateTypesMultiSelect({ values, onChange }: IProps) {
  const { corporationTypes, loading } = useAllCorporationTypes()

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as number[])
  }

  return (
    <FormControl disabled={loading} fullWidth>
      <InputLabel id='corp-types-mutiple-select-label'>Тип корпорации</InputLabel>
      <Select
        labelId='corp-types-mutiple-select-label'
        id='corp-types-mutiple-select'
        multiple
        value={values}
        onChange={handleChange}
        input={<Input />}
        renderValue={selected =>
          corporationTypes
            .filter(t => (selected as number[]).includes(t.id))
            .map(t => t.name)
            .join(', ')
        }
        // MenuProps={MenuProps}
        fullWidth
      >
        {corporationTypes.map(type => (
          <MenuItem key={`corpT-${type.id}`} value={type.id}>
            <Checkbox checked={values.indexOf(type.id) > -1} />
            <ListItemText primary={type.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
